module.exports = __webpack_public_path__ + "img/soundlink.d7420d75.png";